/* eslint-disable camelcase */
// @mui
import { useMemo, useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import { Box, Divider, Container, Grid, Stack, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { getYear } from 'date-fns';
import { useNavigate } from 'react-router-dom';

import Iconify from '../../components/Iconify';
import Image from '../../components/Image';
import { useSelector } from '../../redux/store';
import useLocales from '../../hooks/useLocales';
import palette from '../../theme/palette';
import conObj from '../../utils/connection-assistant';
import SocialFab from '../../components/SocialFab';

const StyledTypography = styled(Typography)(({ theme }) => ({
  '&': {
    color: 'white',
    fontWeight: 600,
    textTransform: 'uppercase',
  },
}));

const FooterText = styled(Typography)(({ theme }) => ({
  color: 'white',
  fontWeight: 480,
  fontSize: 12,
}));

const StyledImage = styled(Image)(({ theme }) => ({
  width: 340,
  height: 60,

  [theme.breakpoints.up('sm')]: {
    width: 340,
    height: 60,
  },
  [theme.breakpoints.down('sm')]: {
    width: '85vw',
    height: '17vw',
    objectFit: 'contain',
  },
}));

const CustomScrollbar = styled(Stack)({
  overflowY: 'hidden',
  scrollbarWidth: 'thin',
  scrollbarColor: 'grey #2b2b2b',
  '&::-webkit-scrollbar': {
    width: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: '#2b2b2b',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#f48fb1',
    borderRadius: '10px',
    border: '2px solid #2b2b2b',
  },
});

const SocialIconBox = styled(Box)(({ theme }) => ({
  cursor: 'pointer',
}));

const Footer = () => {
  const navigate = useNavigate();

  const { enqueueSnackbar } = useSnackbar();

  const { translate } = useLocales();

  const { siteSettings } = useSelector((x) => x.lookup);

  const [pages, setPages] = useState([]);

  const [activeCompanies, setActiveCompanies] = useState([]);

  const {
    config_footer_copyright,
    config_name,
    config_facebook,
    config_instagram,
    config_line,
    config_messenger,
    config_telegram,
    config_twitter,
    config_viber,
    config_wechat,
    config_whatsapp,
    config_youtube,
  } = siteSettings || {};

  useEffect(() => {
    /**
     * Get custom pages like TnC etc.
     */
    getPages();

    getActiveCompanies();
  }, []);

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    enqueueSnackbar('Copied!');
  };

  const copyrightText = useMemo(() => {
    if (config_footer_copyright) {
      const newText = config_footer_copyright.replace('[year]', getYear(new Date())).replace('[name]', config_name);

      console.log(newText);

      return newText;
    }

    return '';
  }, [siteSettings?.config_footer_copyright, siteSettings?.config_name]);

  const openSocial = (link) => {
    window.open(
      link,
      '_blank'
      // 'noopener noreferrer'
    );
  };

  const getPages = () => {
    conObj
      .post(`/pages.json`)
      .then((res) => {
        if (res.status === 200) {
          if (res.data?.data?.data?.length > 0) {
            setPages(res.data?.data?.data?.map((item) => ({ pageKey: item?.page_key, title: item?.title })));
          }
        }
      })
      .catch((err) => {
        console.log(`Error: ${err?.message}`);
      });
  };

  const getActiveCompanies = () => {
    conObj.post('/games/active_companies.json').then((res) => {
      if (res.status === 200) {
        setActiveCompanies(res.data?.data?.data);
      }
    });
  };

  const displayGameProvidersComponent = (items) => {
    const midIndex = Math.ceil(items.length / 2);
    const firstHalf = items.slice(0, midIndex);
    const secondHalf = items.slice(midIndex);

    return (
      <CustomScrollbar
        direction={'column'}
        spacing={1}
        sx={{
          overflowX: 'scroll',
          mt: 2,
          ml: 0,
          width: '100%',
          px: '20px',
        }}
      >
        <Stack direction={'row'} spacing={1} sx={{ height: '42px' }}>
          {firstHalf.map((item, index) => (
            <Image key={index} src={item?.logo_url} alt="Providers" sx={{ minWidth: '96px', height: '42px' }} />
          ))}
        </Stack>

        <Stack direction={'row'} spacing={1} sx={{ height: '42px' }}>
          {secondHalf.map((item, index) => (
            <Image key={index} src={item?.logo_url} alt="Providers" sx={{ minWidth: '96px', height: '42px' }} />
          ))}
        </Stack>
      </CustomScrollbar>
    );
  };

  return (
    <Box sx={{ overflow: 'hidden' }}>
      {/* Player/Winner */}
      {/* <Grid container spacing={1}>
        <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
          <Box sx={{ backgroundColor: '#343a45', borderRadius: '10px', p: '20px', textAlign: 'center' }}>
            <Stack direction="column" alignItems={'center'} justifyContent={'center'}>
              <Typography sx={{ fontSize: '24px', color: '#437bde', fontWeight: 'bolder' }}>915, 190</Typography>
              <Stack direction="row" justifyContent={'center'} alignItems={'center'} spacing={1}>
                <Iconify icon={'fa:group'} width={25} height={25} sx={{ color: 'rgb(152, 172, 208)' }} />
                <Typography sx={{ fontSize: '14px', color: '#98acd0', fontWeight: 'bolder' }}>Player</Typography>
              </Stack>
            </Stack>
          </Box>
        </Grid>
        <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
          <Box sx={{ backgroundColor: '#343a45', borderRadius: '10px', p: '20px', textAlign: 'center' }}>
            <Stack direction="column" alignItems={'center'}>
              <Typography sx={{ fontSize: '24px', color: '#437bde', fontWeight: 'bolder' }}>970, 957</Typography>
              <Stack direction="row" justifyContent={'center'} alignItems={'center'} spacing={1}>
                <Iconify
                  icon={'healthicons:award-trophy'}
                  width={25}
                  height={25}
                  sx={{ color: 'rgb(152, 172, 208)' }}
                />
                <Typography sx={{ fontSize: '14px', color: '#98acd0', fontWeight: 'bolder' }}>Player</Typography>
              </Stack>
            </Stack>
          </Box>
        </Grid>
      </Grid> */}

      <Container
        maxWidth="lg"
        sx={{
          backgroundColor: palette.footer.bgColor2,
          py: '1rem',
          display: 'flex',
          flexDirection: 'column',
          px: '16px',
          alignItems: 'start',
          borderBottom: '.5px solid rgba(145, 158, 171, 0.24)',
        }}
      >
        <Typography sx={{ fontSize: '12px', color: '#fff', fontWeight: 480, width: '100%' }}>
          {translate('payment_method')}
        </Typography>
        <Grid container sx={{ mt: '6px' }} spacing={'10px'}>
          <Grid item>
            <Image
              src={require('../../assets/payment_methods/pm1.png')}
              sx={{ width: '34px', borderRadius: '9999px' }}
            />
          </Grid>

          <Grid item>
            <Image
              src={require('../../assets/payment_methods/pm2.png')}
              sx={{ width: '34px', borderRadius: '9999px' }}
            />
          </Grid>

          <Grid item>
            <Image
              src={require('../../assets/payment_methods/pm3.png')}
              sx={{ width: '34px', borderRadius: '9999px' }}
            />
          </Grid>

          <Grid item>
            <Image
              src={require('../../assets/payment_methods/pm4.png')}
              sx={{ width: '34px', borderRadius: '9999px' }}
            />
          </Grid>

          <Grid item>
            <Image
              src={require('../../assets/payment_methods/pm5.png')}
              sx={{ width: '34px', borderRadius: '9999px' }}
            />
          </Grid>

          <Grid item>
            <Image
              src={require('../../assets/payment_methods/pm6.png')}
              sx={{ width: '34px', borderRadius: '9999px' }}
            />
          </Grid>

          <Grid item>
            <Image
              src={require('../../assets/payment_methods/pm7.png')}
              sx={{ width: '34px', borderRadius: '9999px' }}
            />
          </Grid>

          <Grid item>
            <Image
              src={require('../../assets/payment_methods/pm8.png')}
              sx={{ width: '34px', borderRadius: '9999px' }}
            />
          </Grid>

          <Grid item>
            <Image
              src={require('../../assets/payment_methods/pm9.png')}
              sx={{ width: '34px', borderRadius: '9999px' }}
            />
          </Grid>

          <Grid item>
            <Image
              src={require('../../assets/payment_methods/pm10.png')}
              sx={{ width: '34px', borderRadius: '9999px' }}
            />
          </Grid>

          <Grid item>
            <Image
              src={require('../../assets/payment_methods/pm11.png')}
              sx={{ width: '34px', borderRadius: '9999px' }}
            />
          </Grid>

          <Grid item>
            <Image
              src={require('../../assets/payment_methods/pm12.png')}
              sx={{ width: '34px', borderRadius: '9999px' }}
            />
          </Grid>

          <Grid item>
            <Image
              src={require('../../assets/payment_methods/pm13.png')}
              sx={{ width: '34px', borderRadius: '9999px' }}
            />
          </Grid>

          <Grid item>
            <Image
              src={require('../../assets/payment_methods/pm14.png')}
              sx={{ width: '34px', borderRadius: '9999px' }}
            />
          </Grid>

          <Grid item>
            <Image
              src={require('../../assets/payment_methods/pm15.png')}
              sx={{ width: '34px', borderRadius: '9999px' }}
            />
          </Grid>

          <Grid item>
            <Image
              src={require('../../assets/payment_methods/pm16.png')}
              sx={{ width: '34px', borderRadius: '9999px' }}
            />
          </Grid>
        </Grid>
      </Container>

      <Container
        maxWidth="lg"
        sx={{
          backgroundColor: palette.footer.bgColor,
          p: '1rem 0 !important',
          borderBottom: '.5px solid rgba(145, 158, 171, 0.24)',
        }}
      >
        <Stack direction="row" alignItems={'center'} spacing={2} sx={{ ml: { md: 3, sm: 2, xs: 2 } }}>
          <Typography sx={{ color: 'white', fontWeight: 480, fontSize: '12px' }}>
            {translate('our_game_provides')}
          </Typography>
        </Stack>
        {activeCompanies && displayGameProvidersComponent(activeCompanies?.filter((f) => f?.exists === true))}
        {/* <Box sx={{ display: 'flex', alignItems: 'center', mt: 2, px: 2, overflowX: 'auto', width: '100%' }}>
          <Grid container spacing={1} sx={{ justifyContent: 'center' }}>
            {_gameProviders.map((item, index) => (
              <Grid item>
                <Image key={index} src={item} alt="Providers" sx={{ width: '6rem' }} />
              </Grid>
            ))}
          </Grid>
        </Box> */}
      </Container>

      <Container
        maxWidth="lg"
        sx={{
          backgroundColor: palette.footer.bgColor2,
          py: '1rem',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'start',
          borderBottom: '.5px solid rgba(145, 158, 171, 0.24)',
        }}
      >
        <FooterText sx={{ textTransform: 'uppercase', fontSize: '12px', fontWeight: 480 }}>
          {translate('contact_us_24')}
        </FooterText>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: '0.2rem' }}>
          <Box
            sx={{
              backgroundColor: 'white',
              borderRadius: '50%',
              width: '1.3rem',
              height: '1.3rem',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              mb: '.2rem',
            }}
          >
            <Iconify icon="heroicons-solid:chat" sx={{ color: 'black', fontSize: '1.2rem' }} />
          </Box>
          <FooterText sx={{ fontSize: '0.5rem' }}>{translate('live_chat')}</FooterText>
          <FooterText sx={{ fontSize: '0.7rem', fontWeight: 500, color: 'rgb(219, 67, 20)', lineHeight: 1 }}>
            {translate('')}
          </FooterText>
        </Box>
      </Container>

      <Container maxWidth="lg" sx={{ p: 2, background: palette.footer.bgColor3 }}>
        <Stack spacing={1}>
          <FooterText>{translate('gaming_license')}</FooterText>
          <Box>
            <Image
              src={require('../../assets/powered/gaming-curacao-logo.png')}
              sx={{ width: '128px', height: '41px' }}
            />
          </Box>

          <FooterText sx={{ fontSize: '0.6rem' }}>{translate('gaming_license_caption')}</FooterText>
        </Stack>

        <Stack spacing={1} sx={{ mt: 5 }}>
          <FooterText>{translate('certification')}</FooterText>
          <Box sx={{ display: 'flex' }}>
            <Image src={require('../../assets/powered/bmm.png')} sx={{ width: '45px', height: '26px' }} />
            <Image src={require('../../assets/powered/itech.png')} sx={{ width: '26px', height: '26px' }} />
          </Box>
          <Image src={require('../../assets/powered/verified.png')} sx={{ width: '96px', height: '24px' }} />
        </Stack>

        <Box>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <Box>
                <Stack spacing={1} sx={{ mt: 5 }}>
                  <FooterText>{translate('security')}</FooterText>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Box>
                      <Image
                        src={require('../../assets/powered/iovation.png')}
                        sx={{ width: '91px', height: '19px' }}
                      />
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Image
                        src={require('../../assets/powered/threat-metrix.png')}
                        sx={{ width: '27px', height: '27px' }}
                      />
                      <FooterText sx={{ fontSize: '0.8rem', fontWeight: 300 }}>{translate('threatmetrix')}</FooterText>
                    </Box>
                  </Box>
                </Stack>
              </Box>
            </Grid>
            <Grid item xs={4}>
              <Box>
                <Stack spacing={1} sx={{ mt: 5 }}>
                  <FooterText>{translate('responsible_gaming')}</FooterText>
                  <Box sx={{ display: 'flex' }}>
                    <Box>
                      <Image src={require('../../assets/powered/18.png')} sx={{ width: '21px', height: '20px' }} />
                    </Box>
                    <Box sx={{ mx: 1 }}>
                      <Image
                        src={require('../../assets/powered/gamcare-logo.png')}
                        sx={{ width: '16px', height: '21px' }}
                      />
                    </Box>
                    <Box>
                      <Image
                        src={require('../../assets/powered/be-gamble-aware-logo.png')}
                        sx={{ width: '39px', height: '20px' }}
                      />
                    </Box>
                  </Box>
                </Stack>
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Stack direction={'row'} spacing={1} sx={{ width: '100%', mt: '2rem' }}>
          {pages?.length > 0 &&
            pages.map((item, index) => (
              <Typography
                onClick={() => navigate(`/page/${item?.pageKey}`)}
                variant="caption"
                sx={{
                  cursor: 'pointer',
                  fontSize: '10px',
                  color: '#fff',
                  display: 'block',
                  fontWeight: 600,
                  width: 'auto',
                  textDecoration: 'underline',
                }}
              >
                {item?.title}
              </Typography>
            ))}
        </Stack>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'center',
            mt: '2rem',
          }}
        >
          <StyledTypography sx={{ fontSize: '.5rem' }}>{copyrightText}</StyledTypography>

          <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
            {config_line && (
              <SocialIconBox onClick={() => openSocial(config_line)}>
                <Image src={require('../../assets/social/line.png')} sx={{ width: '23px', height: '24px' }} />
              </SocialIconBox>
            )}
            {config_facebook && (
              <SocialIconBox onClick={() => openSocial(config_facebook)}>
                <Image src={require('../../assets/social/fb.png')} sx={{ width: '23px', height: '24px' }} />
              </SocialIconBox>
            )}
            {config_instagram && (
              <SocialIconBox onClick={() => openSocial(config_instagram)}>
                <Image src={require('../../assets/social/instagram.png')} sx={{ width: '23px', height: '24px' }} />
              </SocialIconBox>
            )}
            {config_messenger && (
              <SocialIconBox onClick={() => openSocial(config_messenger)}>
                <Image src={require('../../assets/social/messenger.png')} sx={{ width: '23px', height: '24px' }} />
              </SocialIconBox>
            )}
            {config_telegram && (
              <SocialIconBox onClick={() => openSocial(config_telegram)}>
                <Image src={require('../../assets/social/telegram.png')} sx={{ width: '23px', height: '24px' }} />
              </SocialIconBox>
            )}
            {config_twitter && (
              <SocialIconBox onClick={() => openSocial(config_twitter)}>
                <Image src={require('../../assets/social/twitter.png')} sx={{ width: '23px', height: '24px' }} />
              </SocialIconBox>
            )}
            {config_viber && (
              <SocialIconBox onClick={() => openSocial(config_viber)}>
                <Image src={require('../../assets/social/viber.png')} sx={{ width: '23px', height: '24px' }} />
              </SocialIconBox>
            )}
            {config_wechat && (
              <SocialIconBox onClick={() => openSocial(config_wechat)}>
                <Image src={require('../../assets/social/wechat.png')} sx={{ width: '23px', height: '24px' }} />
              </SocialIconBox>
            )}
            {config_whatsapp && (
              <SocialIconBox onClick={() => openSocial(config_whatsapp)}>
                <Image src={require('../../assets/social/wa.png')} sx={{ width: '23px', height: '24px' }} />
              </SocialIconBox>
            )}
            {config_youtube && (
              <SocialIconBox onClick={() => openSocial(config_youtube)}>
                <Image src={require('../../assets/social/yt.png')} sx={{ width: '23px', height: '24px' }} />
              </SocialIconBox>
            )}
          </Stack>
        </Box>
        {/* <Grid container spacing={{ sm: 1, xs: 2 }}>
          <Grid item sm={12 / 5} xs={12 / 2}>
            <Stack direction={'column'} spacing={1}>
              <Image
                src={require('../../assets/brand-logo.png')}
                sx={{
                  height: '40px',
                  width: 'auto',
                  maxWidth: '130px',
                  '& img': {
                    objectFit: 'contain',
                  },
                }}
              />
            </Stack>
          </Grid>
          <Grid item sm={12 / 5} xs={12 / 2}>
            <Stack direction={'column'} spacing={1}>
              <FooterText sx={{ fontWeight: 600 }}>HELPFUL LINKS</FooterText>
              <FooterText>All Games</FooterText>
              <FooterText>Slots</FooterText>
              <FooterText>Live Casino</FooterText>
            </Stack>
          </Grid>
          <Grid item sm={12 / 5} xs={12 / 2}>
            <Stack direction={'column'} spacing={1}>
              <FooterText sx={{ fontWeight: 600 }}>PLATFORM</FooterText>
              <FooterText>Support</FooterText>
              <FooterText>FAQ</FooterText>
              <FooterText>Slots</FooterText>
              <FooterText>Partnetship Program</FooterText>
              <FooterText>Help Center</FooterText>
            </Stack>
          </Grid>
          <Grid item sm={12 / 5} xs={12 / 2}>
            <Stack direction={'column'} spacing={1}>
              <FooterText sx={{ fontWeight: 600 }}>ABOUT US</FooterText>
              <FooterText>AML Policy</FooterText>
              <FooterText>Sports Policy</FooterText>
              <FooterText>Responsible Gaming</FooterText>
              <FooterText>Privacy Policy</FooterText>
              <FooterText>Terms and Conditions</FooterText>
            </Stack>
          </Grid>
          <Grid item sm={12 / 5} xs={12 / 2}>
            <Stack direction={'column'} spacing={1}>
              <FooterText sx={{ fontWeight: 600 }}>COMMUNITY</FooterText>
              <FooterText>AML Policy</FooterText>
              <FooterText>Sports Policy</FooterText>
              <FooterText>Responsible Gaming</FooterText>
              <FooterText>Privacy Policy</FooterText>
              <FooterText>Terms and Conditions</FooterText>
            </Stack>
          </Grid>
        </Grid> */}
      </Container>
      <SocialFab />
    </Box>
  );
};

export default Footer;
